<!-- tl-section-panel: no elevation, radius or fill, so the panel does not read as a card inside
     the card this field sits in. tl-multiselect-panel carries this field's own header tweaks. -->
<mat-expansion-panel
  class="tl-section-panel tl-multiselect-panel"
  [expanded]="expanded"
  #expansionPanel
>
  <mat-expansion-panel-header>
    <mat-panel-title class="flex flex-row items-center">
      <!-- col=0 so the field stops claiming a Bootstrap grid column: col-md-8 made it 66% wide
           and stretched the checkbox away from its label. -->
      <app-form-field
        class="tl-panel-header-toggle flex-none"
        [formGroup]="headerFormGroup"
        fieldControlName="headerToggle"
        type="checkbox"
        [col]="0"
        [noBottomGap]="true"
        (click)="$event.stopPropagation()"
        [indeterminate]="master_indeterminate"
        [formState]="master_checked"
      >
        <ng-container post-content>
          <div
            class="flex flex-nowrap items-center gap-1 whitespace-nowrap pl-2"
            (click)="expansionPanel.toggle()"
          >
            <span>{{ headerLabel | translate }}</span>
            <span class="selected-item-count text-xs font-bold">
              ({{ selectedCount }} enabled)</span
            >
          </div>
        </ng-container>
      </app-form-field>
    </mat-panel-title>
  </mat-expansion-panel-header>
  <div [formGroup]="formGroup">
    <app-view-model-checkbox-list
      #childSelectControl
      [formGroup]="formGroup"
      [formControlName]="fieldControlName"
      [options]="options"
      class="flex flex-col"
      (checkboxChanged)="checkboxChanged.emit($event)"
    >
    </app-view-model-checkbox-list>
  </div>
</mat-expansion-panel>
